import React, { useState, useEffect } from 'react';
import { Grid, Paper } from '@material-ui/core';
import { CentalDeVidaStyle } from '../../domain/CentalDeVidaStyle';
import MigaPan from '../../../app/orussystem/component/MigaPan';
import { List } from './List';
import { ModalSttingsScale } from './component/modalSettingsScale';
import { ModalSupervisores } from './component/modalsupervisores';
import { getlist, getlisthash } from '../../domain/api/EvbiApi';
import { useDispatch } from 'react-redux';
import { ROL_USER, USER_ID } from '../../../app/api-client/constants';
import { Store } from 'react-notifications-component';

const ListMachine = (props) => {

    const classes = CentalDeVidaStyle();
    const dispath = useDispatch();


    const id_user_login = localStorage.getItem(USER_ID)
    const rol_user_login = localStorage.getItem(ROL_USER)


    //Variables Modal 
    const [isOpenModal, setisOpenModal] = useState(false)
    const [isOpenModalSup, setisOpenModalSup] = useState(false)

    const [dataEdit, setdataEdit] = useState([])
    const [dataSup, setdataSup] = useState([])


    // ListDepartamentos
    const [listDepas] = useState([])
    const [totalElements, setTotalElements] = useState(0)


    //Lista de basculas
    const [basculas, setBasculas] = useState([]);


    const handledEditSettings = (data) => {
        setdataEdit(data)
        setisOpenModal(!isOpenModal)
    }
    const handleSupervisor = (data) => {
        setdataSup(data)
        setisOpenModalSup(!isOpenModalSup)
    }



    const handledAlert = (title, message, type) => {
        Store.addNotification({
            title: title,
            message: message,
            type: type,
            insert: "top",
            container: "top-right",
            animationIn: ["animate__animated", "animate__fadeIn"],
            animationOut: ["animate__animated", "animate__fadeOut"],
            dismiss: {
                duration: 5000,
                onScreen: true
            }
        });
        setTimeout(() => {

        }, 1000);
    }

    const reload = async (filter, page, size) => {

        let basculas = [];

        //Se verifica el rol de usuario para consumir el servicio.
        if (rol_user_login === 'ROLE_ADMIN') {
            basculas = await getlist(dispath, filter, page, size);
        } else {
            basculas = await getlisthash(dispath, id_user_login, filter, page, size);
        }

        try {
            //se setea basculas con el total elements para el tamaño total de la lista
            if (basculas.error !== "Internal Server Error") {
                setTotalElements(basculas.totalElements)
                setBasculas(basculas.content)
            } else {

                setBasculas([])
                handledAlert("Alerta", "No hay basculas asignadas para este usuario", "warning")
            }

        } catch (error) {

        }

    }

    useEffect(() => {
        const fetchData = async () => {
            try {
                await reload("", 0, 10);
            } catch (error) {
                // Handle any errors here
            }
        };
    
        fetchData();
    }, []);



    return (
        <>


            {isOpenModal && <ModalSttingsScale
                setopenMondal={setisOpenModal}
                isOpen={isOpenModal}
                data={dataEdit}
                listDepartamentos={listDepas}
                reload={reload}
            />}
            {isOpenModalSup && <ModalSupervisores
                setopenMondal={setisOpenModalSup}
                isOpen={isOpenModalSup}
                data={dataSup}
                reload={reload}
            />}
            <Grid item xs={12} >
                <br></br>
                <br></br>
                <MigaPan namePage="Estaciones" to="/" >
                    Home
                </MigaPan>
            </Grid>
            <Grid item xs={12}>
                <Paper className={classes.paper} >
                    <List
                        handledEditSettings={handledEditSettings}
                        data={basculas}
                        reload={reload}
                        totalElements={totalElements}
                        handleSupervisor={handleSupervisor}
                    />
                </Paper>
            </Grid>
        </>


    );
}

export default ListMachine;